<template>
<div class="chapter">
<div class="inner_page">
<section class="part" epub:type="part" id="part-001"><span epub:type="pagebreak" id="page_13" title="13">
<div class="part_debut"></div>
<h1 class="part_n" epub:type="title"><span>PART ONE</span></h1>
<h1 class="part_tit" epub:type="title"><span>B<span class="small">IBLICAL</span><br/>
    I<span class="small">NTERPRETATION</span><br/><i>in the</i> R<span class="small">EFORMATION</span></span></h1>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p1.vue?f8d7443a